import { useLanguage } from '../i18n/LanguageContext';

interface LanguageSwitcherProps {
  className?: string;
  variant?: 'default' | 'inline';
}

export default function LanguageSwitcher({ className = '', variant = 'default' }: LanguageSwitcherProps) {
  const { lang, setLang } = useLanguage();

  if (variant === 'inline') {
    return (
      <div className={`lang-switcher-inline ${className}`}>
        <button
          type="button"
          className={`lang-option ${lang === 'ar' ? 'active' : ''}`}
          onClick={() => setLang('ar')}
          aria-label="Switch to Arabic"
        >
          Ar
        </button>
        <span className="lang-separator">|</span>
        <button
          type="button"
          className={`lang-option ${lang === 'en' ? 'active' : ''}`}
          onClick={() => setLang('en')}
          aria-label="Switch to English"
        >
          En
        </button>
      </div>
    );
  }

  return (
    <button
      type="button"
      className={`lang-switcher ${className}`}
      onClick={() => setLang(lang === 'en' ? 'ar' : 'en')}
      aria-label={lang === 'en' ? 'Switch to Arabic' : 'Switch to English'}
    >
      {lang === 'en' ? 'عربي' : 'English'}
    </button>
  );
}
